module.exports = __webpack_public_path__ + "static/media/carddetails.4f7eb1f9.png";